<template>
  <el-form-item ref="elFormItem"
                :class="['rc-radio-run', component.properties.sortType==='hidden' && 'hidden',component.properties.sortType==='toTop' && 'to-top' ,{removeError:errorFlag, 'disable-copy': component.properties.disableCopy}]"
                :prop="getProp" :rules="rules" :label="component.properties.sortType==='hidden' ? '' : labelParameter.labelName" :title="component.name" :label-width="labelParameter.width">
    <div v-if="labelParameter.showSlot" :class="['control-label', labelParameter.className]" slot="label">{{labelParameter.labelName}}</div>
    <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
      <span class="fa fa-question-circle"></span>
    </el-tooltip>
    <el-radio-group :class="['radio-group-run', component.properties.sortOrientation === 'vertical' ? 'radio-vertical' : 'radio-horizontal']" v-model="select" :style="{'height':height}" @change="changeValue">
      <el-radio v-for="(option, index) in options" :key="index" :title="option.value" :label="option.value" :disabled="disabled || component.properties.readonly"></el-radio>
    </el-radio-group>
  </el-form-item>
</template>

<script>
import { componentMixin, inputMixin, dataSource, calculationMixin } from './mixins'
import { heightMixin } from '@/components/shared/designAndRuntimeMixins/mixins.js'
export default {
  name: 'rc-radio',
  mixins: [ componentMixin, inputMixin, heightMixin, dataSource, calculationMixin ],
  props: [ 'component', 'value', 'index', 'disabled', 'labelParameter' ],
  data () {
    let select = this.value || ''
    return {
      select,
      options: [],
      errorFlag: false
    }
  },
  mounted () {
    // 因为涉及到了监听, 在初始化的时候需要等待数据模型构建完成, 才能去执行相关步骤
    this.$nextTick(() => {
      if (this.component.properties.dataSource && this.component.properties.dataSource.enable) {
        this.loadDataSourceOptions()
      } else {
        this.loadTemplateOptions()
      }
    })
  },
  watch: {
    value (val) {
      this.errorFlag = (Array.from(this.$refs.elFormItem.$el.classList).includes('is-error') && val)
      if (val !== this.select) {
        this.select = val
      }
    }
  },
  methods: {
    changeValue (val) {
      this.update(val)
      // 处理数据绑定
      this.handleBindData(val)
      // 触发值改变事件
      this.$nextTick(() => this.executeFunctions('change'))
    },
    handleBindData (val) {
      // 开启了绑定数据源
      if (this.component.properties.dataSource.bindData.enable && this.component.properties.dataSource.bindData.dataBinding.length > 0) {
        this.component.properties.dataSource.bindData.dataBinding.forEach(d => {
          // todo:单选复选只有一个值且是以文本作为值的，这里也是通过文本值去比对，可能会有不准确的问题
          let o = this.options.find(e => e.value === val)
          this.update({'value': val === null || val === undefined || val === '' ? '' : o[d.showColumnId], 'archiveColumnId': d.componentId})
        })
      }
    }
  }
}
</script>
<style lang="scss">
  .removeError{
    .el-form-item__error{
      opacity: 0;
    }
  }
  .rc-radio-run{
    .el-form-item__content{
      line-height: 0;
    }
    .radio-group-run {
      overflow-y: auto;
      width: 100%;
      height: 100%;
      label.el-radio {
        margin-left: 30px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        padding: 7px 0 3px;
      }
      &.radio-horizontal{
        .el-radio{
          display: inline-block;
          width: 110px;
          margin-right: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-radio.vue